<template>
  <div class="svg-wrapper">
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2166.28 1875.35" width="100">
      <rect class="cls-1 svg-elem-1" width="2166.28" height="1875.35"></rect>
      <polygon
        class="cls-2 svg-elem-2"
        points="1352.53 1493.38 909.56 1493.38 860.04 822.05 827.02 802.79 807.76 701 1448.83 701 1428.46 802.79 1396.26 822.97 1352.53 1493.38"
      ></polygon>
      <path
        class="cls-3 svg-elem-3"
        d="M891.54,1250.07s55.3,94.57,181.09,38.18,217.11-87,294.73-21.22l-14.83,227.35h-443Z"
        transform="translate(0 -1)"
      ></path>
      <path
        class="cls-4 svg-elem-4"
        d="M899.06,1352s110,77.93,254.54-20.38,212.7-48.23,212.7-48.23l-13.76,211h-443Z"
        transform="translate(0 -1)"
      ></path>
      <polygon
        class="cls-5 svg-elem-5"
        points="1303.29 427.69 1102.14 1170.74 1013.22 1170.74 1212.64 427.69 1303.29 427.69"
      ></polygon>
      <rect class="cls-6 svg-elem-6" x="787.65" y="671.43" width="694.04" height="40.57"></rect>
      <polygon
        class="cls-7 svg-elem-7"
        points="1212.64 427.69 1303.29 427.69 1238.9 671.43 1148.64 671.43 1212.64 427.69"
      ></polygon>
      <polygon
        class="cls-8 svg-elem-8"
        points="1205.91 671.43 1271.9 427.69 1303.29 427.69 1238.9 671.43 1205.91 671.43"
      ></polygon>
      <circle class="cls-9 svg-elem-9" cx="1305.15" cy="1346.53" r="30.41"></circle>
      <circle class="cls-9 svg-elem-10" cx="1229.21" cy="1429.65" r="38.91"></circle>
      <circle class="cls-9 svg-elem-11" cx="1186.91" cy="1354.23" r="27.28"></circle>
      <circle class="cls-9 svg-elem-12" cx="1087.69" cy="1434.45" r="32.99"></circle>
      <circle class="cls-9 svg-elem-13" cx="995.04" cy="1364.5" r="36.97"></circle>
      <circle class="cls-10 svg-elem-14" cx="1220.99" cy="1280.74" r="36.97"></circle>
      <circle class="cls-11 svg-elem-15" cx="1099.66" cy="1261.87" r="40.92"></circle>
      <circle class="cls-12 svg-elem-16" cx="995.04" cy="1217.88" r="36.97"></circle>
      <circle class="cls-13 svg-elem-17" cx="976.24" cy="1082.7" r="36.97"></circle>
      <circle class="cls-14 svg-elem-18" cx="1189.75" cy="1142.89" r="36.97"></circle>
      <circle class="cls-15 svg-elem-19" cx="1305.09" cy="1105.92" r="36.97"></circle>
      <path
        class="cls-16 svg-elem-20"
        d="M869,944.81s132-69.33,253.49,49.23,262.78,0,262.78,0l10.82-167.71H860.28Z"
        transform="translate(0 -1)"
      ></path>
      <path
        class="cls-11 svg-elem-21"
        d="M821.23,773.18L827,803.8l33,19.26,4.38,59.44s118.64-47.77,304.35,47.93c156.62,80.71,223.92-51.16,223.92-51.16l3.57-55.29,32.2-20.18,6.28-30.61H821.23Z"
        transform="translate(0 -1)"
      ></path>
      <path
        class="cls-15 svg-elem-22"
        d="M824.17,788.74S1033.84,858.91,1184,816s235.61-6.72,235.61-6.72l8.83-5.53,6.28-30.61H821.23Z"
        transform="translate(0 -1)"
      ></path>
    </svg>
  </div>
</template>
<script>
import { nextTick, onBeforeUnmount } from 'vue';
export default {
  name: 'bubble-tea',
  setup() {
    let timer;
    const init = (async function () {
      await nextTick();
      let wrapper = document.querySelector('.svg-wrapper svg');
      const animation = () => {
        wrapper.classList.add('active');
        setTimeout(() => {
          wrapper.classList.remove('active');
        }, 3000);
        return animation;
      };
      setTimeout(() => {
        timer && clearInterval(timer);
        timer = setInterval(animation(), 7000);
      }, 1000);
    })();
    onBeforeUnmount(() => {
      clearInterval(timer);
    });
    return { init };
  },
};
</script>
<style lang="scss" scoped>
.svg-wrapper {
  width: 50px;
  height: 60px;
  overflow: hidden;
}
svg {
  transform: translate(-26px, -20px);
}
svg .svg-elem-1 {
  fill: transparent;
}

svg .svg-elem-2 {
  fill: rgb(250, 239, 220);
  -webkit-transition: fill 0.6s ease 0.5s;
  transition: fill 0.6s ease 0.5s;
}

svg.active .svg-elem-2 {
  fill: rgb(250, 239, 220);
}

svg .svg-elem-3 {
  fill: transparent;
  -webkit-transition: fill 0.6s ease 0.6s;
  transition: fill 0.6s ease 0.6s;
}

svg.active .svg-elem-3 {
  fill: rgb(244, 184, 74);
}

svg .svg-elem-4 {
  fill: transparent;
  -webkit-transition: fill 0.6s ease 0.7s;
  transition: fill 0.6s ease 0.7s;
}

svg.active .svg-elem-4 {
  fill: rgb(236, 146, 33);
}

svg .svg-elem-5 {
  fill: rgb(187, 179, 165);
}

svg .svg-elem-6 {
  fill: rgb(38, 38, 38);
}

svg .svg-elem-7 {
  fill: rgb(99, 89, 71);
}

svg .svg-elem-8 {
  fill: rgb(60, 47, 25);
}

svg .svg-elem-9 {
  fill: transparent;
  -webkit-transition: fill 0.6s ease 1s;
  transition: fill 0.6s ease 1s;
}

svg.active .svg-elem-9 {
  fill: rgb(96, 57, 19);
}

svg .svg-elem-10 {
  fill: transparent;
  -webkit-transition: fill 0.6s ease 1.1s;
  transition: fill 0.6s ease 1.1s;
}

svg.active .svg-elem-10 {
  fill: rgb(96, 57, 19);
}

svg .svg-elem-11 {
  fill: transparent;
  -webkit-transition: fill 0.6s ease 1.2s;
  transition: fill 0.6s ease 1.2s;
}

svg.active .svg-elem-11 {
  fill: rgb(96, 57, 19);
}

svg .svg-elem-12 {
  fill: transparent;
  -webkit-transition: fill 0.6s ease 1.3s;
  transition: fill 0.6s ease 1.3s;
}

svg.active .svg-elem-12 {
  fill: rgb(96, 57, 19);
}

svg .svg-elem-13 {
  fill: transparent;
  -webkit-transition: fill 0.6s ease 1.4000000000000001s;
  transition: fill 0.6s ease 1.4000000000000001s;
}

svg.active .svg-elem-13 {
  fill: rgb(96, 57, 19);
}

svg .svg-elem-14 {
  fill: transparent;
  -webkit-transition: fill 0.6s ease 1.5s;
  transition: fill 0.6s ease 1.5s;
}

svg.active .svg-elem-14 {
  fill: rgb(173, 94, 17);
}

svg .svg-elem-15 {
  fill: transparent;
  -webkit-transition: fill 0.6s ease 1.6s;
  transition: fill 0.6s ease 1.6s;
}

svg.active .svg-elem-15 {
  fill: rgb(235, 161, 74);
}

svg .svg-elem-16 {
  fill: transparent;
  -webkit-transition: fill 0.6s ease 1.7s;
  transition: fill 0.6s ease 1.7s;
}

svg.active .svg-elem-16 {
  fill: rgb(243, 199, 146);
}

svg .svg-elem-17 {
  fill: transparent;
  -webkit-transition: fill 0.6s ease 1.8s;
  transition: fill 0.6s ease 1.8s;
}

svg.active .svg-elem-17 {
  fill: rgb(246, 214, 163);
}

svg .svg-elem-18 {
  fill: transparent;
  -webkit-transition: fill 0.6s ease 1.9000000000000001s;
  transition: fill 0.6s ease 1.9000000000000001s;
}

svg.active .svg-elem-18 {
  fill: rgb(247, 217, 183);
}

svg .svg-elem-19 {
  fill: transparent;
  -webkit-transition: fill 0.6s ease 2s;
  transition: fill 0.6s ease 2s;
}

svg.active .svg-elem-19 {
  fill: rgb(240, 187, 101);
}

svg .svg-elem-20 {
  fill: transparent;
  -webkit-transition: fill 0.6s ease 2.1s;
  transition: fill 0.6s ease 2.1s;
}

svg.active .svg-elem-20 {
  fill: rgb(249, 225, 185);
}

svg .svg-elem-21 {
  fill: transparent;
  -webkit-transition: fill 0.6s ease 2.2s;
  transition: fill 0.6s ease 2.2s;
}

svg.active .svg-elem-21 {
  fill: rgb(235, 161, 74);
}

svg .svg-elem-22 {
  fill: transparent;
  -webkit-transition: fill 0.6s ease 2.3000000000000003s;
  transition: fill 0.6s ease 2.3000000000000003s;
}

svg.active .svg-elem-22 {
  fill: rgb(240, 187, 101);
}
</style>
